module.exports = __webpack_public_path__ + "static/media/jetblack.2e698a9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprayhoodColors/jetblack.jpg
// module id = 705
// module chunks = 0